<template>
  <div class="review-content">
    <h2 class="review-content__heading">
      Sweet.
      <br />Your <span class="lowercase">my</span>BOOM 3 is Complete.
    </h2>

    <p class="review-content__body">
      Proceed to checkout or save your design to revise and purchase at any
      time. And please check your design for accuracy. We will not accept
      returns for custom designs made in error.
      <a
        :href="
          'https://buy.ultimateears.com/store/logib2c/' +
            transformedLocale +
            '/DisplayReturnAndCancellationsPage/ThemeID.8545600'
        "
        target="_blank"
        >See myBOOM returns policy</a
      >.
    </p>
    <div class="btn--buy-now-mobile-wrapper" v-if="locale === 'en-au'">
      <button
      disabled
        class="btn btn--has-image btn--buy-now-mobile btn--inverse btn--full-width"
        @click="buyModal"
      >
        <img src="/images/cart.png" alt /> Buy Now
      </button>
    </div>
    <div class="btn--buy-now-mobile-wrapper" v-else>
      <button
        class="btn btn--has-image btn--buy-now-mobile btn--inverse btn--full-width"
        @click="buyModal"
      >
        <img src="/images/cart.png" alt /> Buy Now
      </button>
    </div>
    <div class="custom-information">
      <h3 class="custom-information__heading">myBOOM 3</h3>
      <p
        class="custom-information__custom-text"
        v-if="customText && customText.length > 0"
      >
        {{ customText }}
      </p>
      <p class="custom-information__custom-text" v-else>
        <router-link :to="{ name: 'CustomText' }">Add custom text</router-link>
      </p>
      <div class="select-product-wrap">
        <select
          class="select-product"
          id="productOptions"
          name="productOptions"
          v-model="selectedSKU"
        >
          <option
            v-for="(option, index) in productOptions"
            :key="index"
            :value="option.SKU"
            >{{ option.name }}</option
          >
        </select>
      </div>
      <p class="custom-information__price">
        {{ originalPrice }}
        <span v-if="selectedProduct[0].SKU !== productSKU"
          >+ {{ accessoryPrice }}</span
        >
      </p>
      <div class="btn-group" v-if="locale === 'en-au'">
        <button @click="confirmModal" class="btn btn--inverse" disabled>
          Add to Cart
        </button>
        <button class="btn btn--has-border" @click="saveForLaterModal" disabled>
          Save for Later
        </button>
      </div>
      <div class="btn-group" v-else>
        <button @click="confirmModal" class="btn btn--inverse">
          Add to Cart
        </button>
        <button class="btn btn--has-border" @click="saveForLaterModal">
          Save for Later
        </button>
      </div>
    </div>
    <div class="mobile-only">
        <div class="buttons-mobile" v-if="locale === 'en-au'">
        <button
        disabled
          class="btn btn--has-image btn--inverse btn--full-width btn--show-tablet"
          @click="buyModal"
        >
          <img src="/images/cart.png" alt /> Buy Now
        </button>
        <button
        disabled
          class="btn btn--has-border btn--full-width btn--save-for-later-mobile"
          @click="saveForLaterModal"
        >
          Save for Later
        </button>
      </div>
      <div class="buttons-mobile" v-else>
        <button
          class="btn btn--has-image btn--inverse btn--full-width btn--show-tablet"
          @click="buyModal"
        >
          <img src="/images/cart.png" alt /> Buy Now
        </button>
        <button
          class="btn btn--has-border btn--full-width btn--save-for-later-mobile"
          @click="saveForLaterModal"
        >
          Save for Later
        </button>
      </div>
      <Share :generic-share="true" />
    </div>
    <div style="display:none;">
      <!-- share on social media -->
      <div id="share" class="modal modal--share">
        <div class="modal__content-area">
          <h2>Share Your Design</h2>
          <div class="share-image-wrap">
            <Loader class="share-image-wrap__loader" v-show="shareLoading" />
            <img
              class="share-image"
              :class="{ 'share-image--loading': shareLoading }"
              v-show="socialActualURL"
              :src="socialActualURL"
              alt="My myBOOM 3 design"
            />
          </div>
          <Share :standalone="true" :disabled-share="shareLoading" />
        </div>
      </div>
      <!-- save for later -->
      <div id="saveForLater" class="modal">
        <div class="modal__content-area">
          <h2>Sleep On It</h2>
          <p>
            We get it. Design is everything. We’ll email your creation so you
            can take a minute (or up to 30 days) to revise and purchase.
          </p>
          <div class="modal__opt-in">
            <input
              type="checkbox"
              v-model="optIn"
              id="promos"
              name="promos"
              class="modal__checkbox"
            />
            <label for="promos" class="modal__label">
              <span class="modal__fake-checkbox"></span>
              Get hot deals and the freshest product news
            </label>
          </div>
        </div>
        <div class="modal__action-area">
          <label for="email" class="sr-only">Email Address</label>
          <form id="saveForLaterForm" action @submit="saveForLater">
            <div class="modal__action-group">
              <input
                type="email"
                v-model="emailAddress"
                id="email"
                required
                name="email"
                placeholder="Your email"
                class="modal__input"
              />
              <div class="modal__submit-group">
                <button
                  :disabled="wait"
                  class="modal__btn btn btn--inverse"
                  type="submit"
                >
                  Submit
                </button>
                <Loader class="modal__btn-loader" v-if="wait" />
              </div>
            </div>
            <div class="messages">
              <p
                v-if="savedForLater"
                class="messages__message messages__message--success"
              >
                We've sent an email to {{ sentToEmailAddress || "you" }} with a
                link to your myBOOM 3 design.
              </p>
              <p
                v-if="!savedForLater && saveForLaterError"
                class="messages__message messages__message--error"
              >
                Sorry, something went wrong when we tried to send your email.
                Please try again later.
              </p>
            </div>
          </form>
        </div>
      </div>
      <div id="confirmModal" class="modal modal--confirm">
        <div class="modal__content-area modal__content-area--legal">
          <h2>Just one more thing.</h2>
          <p>
            Sorry, our lawyers made us do this. But just make sure your custom
            text is classy and you agree to the terms and conditions below and
            we’ll get to work.
          </p>
          <div class="modal__disclaimer">
            <h3>
              <span class="lowercase">my</span>BOOM 3 TERMS &amp; CONDITIONS
            </h3>
            <p>
              By submitting my awesome myBOOM order, I warrant and represent
              that the custom text is free from representations of threatening,
              obscene, unlawful, or sexually explicit content and that it does
              not infringe on the intellectual property rights, including
              copyright and trademark rights, of any third party.
            </p>
            <p>By submitting my order, I agree:</p>
            <ul>
              <li>
                that notwithstanding the standard terms of sale found on the
                Digital River Ireland Ltd. website, my order for the custom Boom
                is non-cancellable and non-refundable;
              </li>
              <li>
                Ultimate Ears will not accept returns except: (a) in accordance
                with the Ultimate Ears standard product warranty for the BOOM 3;
                or (b) due to any errors in customization made by Ultimate Ears.
              </li>
              <li>to rock my music loud and dance like nobody’s watching.</li>
            </ul>
            <p>
              Warranty information: The Ultimate Ears standard warranty for Boom
              3 applies.
            </p>
            <p class="modal__note">
              NOTE: myBOOM speakers ship from a separate location than our other
              products and accessories and take longer to build and get to you.
              Expect 2 weeks to make and another
              {{ locale === "en-au" ? "2-5" : "1-2" }} weeks for delivery.
              Patience, friends.
            </p>
          </div>
          <div class="btn-group">
            <button
              type="button"
              @click="buyNow"
              :disabled="wait"
              class="btn btn--inverse btn--agree"
              :class="{ 'btn--busy': wait }"
            >
              I agree, get me
              <span class="lowercase">my</span>BOOM
              <Loader
                class="modal__btn-loader modal__btn-loader--overlay modal__btn-loader--overlay-white"
                v-show="wait"
              />
            </button>
            <button
              type="button"
              @click="closeModal"
              :disabled="wait"
              class="btn btn--has-border"
            >
              Oops. Let me modify my order
            </button>
          </div>
        </div>
      </div>
      <!-- buy modal -->
      <div id="buyModal" class="modal modal--transparent modal--buy">
        <div class="speaker-images">
          <div
            class="speaker-images__image"
            :class="{ 'has-power-up': selectedSKU === accessorySKU }"
          >
            <img
              v-if="frontDataURL"
              :src="frontDataURL"
              alt="Front of myBOOM"
            />
          </div>
          <div
            class="speaker-images__image"
            :class="{ 'has-power-up': selectedSKU === accessorySKU }"
          >
            <img v-if="backDataURL" :src="backDataURL" alt="Back of myBOOM" />
          </div>
        </div>
        <h3 class="custom-information__heading">myBOOM 3</h3>
        <div class="select-product-wrap">
          <select
            class="select-product select-product--modal"
            id="productOptions"
            name="productOptions"
            v-model="selectedSKU"
          >
            <option
              v-for="(option, index) in productOptions"
              :key="index"
              :value="option.SKU"
              >{{ option.name }}</option
            >
          </select>
        </div>
        <p class="custom-information__price custom-information__price--modal">
          {{ originalPrice }}
          <span v-if="selectedProduct[0].SKU !== productSKU"
            >+ {{ accessoryPrice }}</span
          >
        </p>
        <div class="btn-group">
          <button @click="triggerConfirmModal" class="btn btn--white">
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import { getCurrencyFormatter } from "@/helpers";
import { EventBus } from "../../eventBus";
import VueCookies from "vue-cookies";
import Share from "@/components/Share.vue";
import ConfigurationCanvasRotator from "@/components/ConfigurationCanvasRotator.vue";
import Loader from "@/components/Loader.vue";
import FetchJsonp from "fetch-jsonp";

function mfpBeforeOpen(isTransparent) {
  $("html").addClass("mfp-helper");
  if (isTransparent) {
    $("html").addClass("mfp-helper--transparent");
  }
}
function mfpBeforeClose() {
  $("html").removeClass("mfp-helper");
}

export default {
  name: "completed-product-text",
  data() {
    return {
      emailAddress: "",
      sentToEmailAddress: "",
      startWindowScroll: 0,
      optIn: false,
      accessToken: null,
      cartURL: null,
      wait: false,
      thumbnailDataURL: null,
      emailDataURL: null,
      socialDataURL: null,
      frontDataURL: null,
      backDataURL: null,
      savedForLater: false,
      saveForLaterError: false,
      studioKioskPID: null,
      shareLoading: false,
    };
  },
  mounted() {
    const that = this;
    EventBus.$on("thumbnailDataURL", (dataURL) => {
      console.log("EB: Here is the thumbnail data URL");
      this.thumbnailDataURL = dataURL;
    });

    EventBus.$on("emailDataURL", (dataURL) => {
      console.log("EB: Here is the email data URL");
      this.emailDataURL = dataURL;
    });
    EventBus.$on("socialDataURL", (dataURL) => {
      console.log("EB: Here is the social data URL");
      this.socialDataURL = dataURL;
    });

    EventBus.$on("frontDataURL", (dataURL) => {
      console.log("EB: Here is the front data URL");
      this.frontDataURL = dataURL;
    });

    EventBus.$on("backDataURL", (dataURL) => {
      console.log("EB: Here is the back data URL");
      this.backDataURL = dataURL;
    });

    EventBus.$on("genericShareModal", () => {
      this.shareLoading = true;
      this.socialDataURL = null;
      $.magnificPopup.open({
        items: {
          src: "#share",
        },
        type: "inline",
        fixedContentPos: true,
        closeMarkup:
          '<button title="%title%" type="button" class="mfp-close"><span class="mfp-close__text">Close</span></button>',
      });
    });

    EventBus.$on("getShareImage", () => {
      this.getShareImageURL().then((res) => {
        this.$store.commit("setSocialImageURL", res.Images[0].FileString);
        // TODO: pinterest image needs to be smaller

        that.$store.commit("selectOption", {
          CategoryName: "ConfigId",
          Id: res.Id,
        });
        this.shareLoading = false;
      });
    });

    if (VueCookies.isKey("studioKioskPID")) {
      console.log("is a cookie");
      this.studioKioskPID = VueCookies.get("studioKioskPID");
    }
  },
  methods: {
    saveForLaterModal() {
      const that = this;
      // this.saveForLater();
      // TODO: what about signing people up for promotional emails?
      $.magnificPopup.open({
        items: {
          src: "#saveForLater",
        },
        type: "inline",
        fixedContentPos: true,
        closeMarkup:
          '<button title="%title%" type="button" class="mfp-close"><span class="mfp-close__text">Close</span></button>',
        callbacks: {
          beforeOpen: mfpBeforeOpen,
          beforeClose: mfpBeforeClose,
        },
      });
    },
    triggerConfirmModal() {
      console.log("trigger the confirm modal");
      this.triggerBuyModal = true;
      $.magnificPopup.instance.close();
    },
    confirmModal() {
      $.magnificPopup.open({
        items: {
          src: "#confirmModal",
        },
        type: "inline",
        fixedContentPos: true,
        closeMarkup:
          '<button title="%title%" type="button" class="mfp-close"><span class="mfp-close__text">Close</span></button>',
        callbacks: {
          beforeOpen: mfpBeforeOpen,
          beforeClose: mfpBeforeClose,
        },
      });
    },
    buyModal() {
      if (!this.frontDataURL) {
        this.getFrontImage();
      }
      if (!this.backDataURL) {
        this.getBackImage();
      }

      // TODO: modal window with options
      const that = this;
      $.magnificPopup.open({
        items: {
          src: "#buyModal",
        },
        type: "inline",
        fixedContentPos: true,
        closeMarkup:
          '<button title="%title%" type="button" class="mfp-close"><span class="mfp-close__text">Close</span></button>',
        callbacks: {
          open: function() {
            that.triggerBuyModal = false;
            if (!$(".speaker-images").getSlick) {
              $(".speaker-images").slick({
                dots: true,
                prevArrow: $(".canvas-rotator-wrapper__btn--previous"),
                nextArrow: $(".canvas-rotator-wrapper__btn--next"),
              });
            } else {
              $(".speaker-images").slick("setPosition");
            }
          },
          beforeOpen: () => {
            mfpBeforeOpen(true);
          },
          beforeClose: mfpBeforeClose,
          afterClose: function() {
            if (that.triggerBuyModal) {
              // this doesn't work if i dont put it in a settimeout for some reason
              setTimeout(function() {
                $.magnificPopup.open({
                  items: {
                    src: "#confirmModal",
                  },
                  fixedContentPos: true,
                  type: "inline",
                  closeMarkup:
                    '<button title="%title%" type="button" class="mfp-close"><span class="mfp-close__text">Close</span></button>',
                });
              }, 0);
            }
          },
        },
      });
    },
    closeModal() {
      $.magnificPopup.instance.close();
    },
    getOptionsArray() {
      // get the array of options for the current config
      return [
        this.$store.state.configuration.Fabric,
        this.$store.state.configuration.Caps,
        this.$store.state.configuration.Icon,
        this.$store.state.configuration.Spine,
        this.$store.state.configuration.Loop,
      ];
    },
    getShareImageURL() {
      const that = this;
      that.getSocialImage();
      return fetch("/api/config/SaveForLater", {
        method: "POST",
        body: JSON.stringify({
          productID: 1, // TODO: get real one. for now this is always going to be 1
          engravingText:
            encodeURIComponent(that.$store.state.configuration.CustomText) ||
            "",
          email: "",
          kioskPId: null,
          contactMe: false,
          engravingFont: that.$store.state.font,
          optionIds: that.getOptionsArray(),
          additionalProducts:
            that.selectedSKU === this.accessorySKU ? [this.accessorySKU] : [],
          images: [
            {
              // only thumbnail is used for saveForLater
              type: 2, // 0=front, 1=back, 2=thumbnail
              fileString: that.socialDataURL,
            },
          ],
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => res.json());
    },
    saveForLater(e) {
      // sends email to user
      e.preventDefault();
      const submitForm = e.target;
      console.log(e.target);
      document.activeElement.blur();
      const that = this;
      // check if email address is valid
      that.emailAddress;

      this.wait = true;
      that.saveForLaterError = false;
      this.getEmailImage();
      fetch("/api/config/SaveForLater", {
        method: "POST",
        body: JSON.stringify({
          productID: 1, // TODO: get real one. for now this is always going to be 1
          engravingText:
            encodeURIComponent(that.$store.state.configuration.CustomText) ||
            "",
          email: that.emailAddress,
          kioskPId: that.studioKioskPID,
          region: that.$store.state.locale,
          contactMe: that.optIn,
          engravingFont: that.$store.state.font,
          optionIds: that.getOptionsArray(),
          additionalProducts:
            this.selectedSKU === this.accessorySKU ? [this.accessorySKU] : [],
          images: [
            {
              // only thumbnail is used for saveForLater
              type: 2, // 0=front, 1=back, 2=thumbnail
              fileString: this.emailDataURL,
            },
          ],
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          console.log(res, "res");
          if (res.ok) {
            return res.json();
          } else {
            throw Error(res.statusText);
          }
        })
        .then((json) => {
          console.log(json, "res.json");
          that.savedForLater = true;
          that.sentToEmailAddress = that.emailAddress;
          that.emailAddress = "";
          that.saveForLaterError = false;
          that.wait = false;
          submitForm.reset();
        })
        .catch((err) => {
          that.savedForLater = false;
          that.saveForLaterError = true;
          that.wait = false;
          console.error(err, "Error when submitting Save for Later");
        });
    },
    getThumbnailImage() {
      console.log("Component: hey EB, please get thumbnail image");
      EventBus.$emit("getThumbnailImage");
    },
    getEmailImage() {
      console.log("Component: hey EB, please get email image");
      EventBus.$emit("getEmailImage");
    },
    getFrontImage() {
      console.log("Component: hey EB, please get front image");
      EventBus.$emit("getFrontImage");
    },
    getBackImage() {
      console.log("Component: hey EB, please get back image");
      EventBus.$emit("getBackImage");
    },
    getSocialImage() {
      console.log("Component: hey EB, please get back image");
      EventBus.$emit("getSocialImage");
    },
    buyNow() {
      // TODO: "busy" indicator while all this does its thing
      console.log("buying now");
      const that = this;
      this.wait = true;
      this.getThumbnailImage();
      this.getFrontImage();
      this.getBackImage();

      // set cookie for current configuration
      VueCookies.set("UEB_Configuration", {
        Fabric: this.$store.state.configuration.Fabric,
        Caps: this.$store.state.configuration.Caps,
        Icon: this.$store.state.configuration.Icon,
        Spine: this.$store.state.configuration.Spine,
        Loop: this.$store.state.configuration.Loop,
        engravingText:
          encodeURIComponent(that.$store.state.configuration.CustomText) || "",
      });

      // check if there is an existing session token.
      if (VueCookies.isKey("UEB_DR_session_token")) {
        // if that cookie exists, we'll just use that session token
        that.$store.commit(
          "setSessionToken",
          VueCookies.get("UEB_DR_session_token")
        );
        that.getAccessToken();
      } else {
        // get the new session token
        FetchJsonp(
          "https://buy.logitech.com/store/logib2c/SessionToken?format=json"
        )
          .then((res) => res.json())
          .then((json) => {
            that.$store.commit("setSessionToken", json.session_token);
            VueCookies.set("UEB_DR_session_token", json.session_token);
            // get the access token
            that.getAccessToken();
          });
      }
    },
    getAccessToken() {
      const that = this;
      fetch(
        `/api/config/GetToken?sessionId=${that.sessionToken}&region=${
          that.$store.state.locale
        }`
      )
        .then((res) => res.json())
        .then((json) => {
          console.log(json);
          // TODO: handle errors
          that.accessToken = json;
          // now finally add something to the cart
          that.postConfiguration();
        });
    },
    postConfiguration() {
      const that = this;
      console.log(that.$store.state.locale, "locale");
      fetch("/api/config/PostConfiguration", {
        method: "POST",
        body: JSON.stringify({
          productID: 1, // TODO: get real one
          engravingText:
            encodeURIComponent(that.$store.state.configuration.CustomText) ||
            "",
          email: that.emailAddress,
          engravingFont: that.$store.state.font,
          optionIds: that.getOptionsArray(),
          sessionId: that.sessionToken,
          region: that.$store.state.locale,
          kioskPId: that.studioKioskPID,
          drToken: that.accessToken,
          additionalProducts:
            this.selectedSKU === this.accessorySKU ? [this.accessorySKU] : [], // TODO: make this support more additional products
          images: [
            {
              type: 0, // 0=front, 1=back, 3=thumbnail
              fileString: this.frontDataURL,
            },
            {
              type: 1, // 0=front, 1=back, 3=thumbnail
              fileString: this.backDataURL,
            },
            {
              type: 2, // 0=front, 1=back, 3=thumbnail
              fileString: this.thumbnailDataURL,
            },
          ],
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((json) => {
          console.log(json, "the json response");
          // TODO: if this fails, display a message
          fetch(
            `/api/config/getcart?drtoken=${that.accessToken}&region=${
              this.$store.state.locale
            }`
          )
            .then((res) => res.json())
            .then((json) => {
              // TODO: if this fails, display a message
              that.cartURL = json;
              window.location.href = that.cartURL;
            });
        });
    },
  },
  computed: {
    transformedLocale() {
      let locale = this.$store.state.locale.split("-");
      // uppercase the region and then separate with an underscore -- en-us => en_US
      locale[1] = locale[1].toUpperCase();
      return locale.join("_");
    },
    locale() {
      return this.$store.state.locale.toLowerCase();
    },
    accessorySKU() {
      return this.$store.state.accessorySKU;
    },
    productSKU() {
      return this.$store.state.productSKU;
    },
    selectedSKU: {
      get() {
        return this.$store.state.selectedSKU;
      },
      set(val) {
        this.$store.commit("selectSKU", val);
      },
    },
    speakerBeingConfigured() {
      return this.$store.state.productBeingConfigured;
    },
    productOptions() {
      return [
        {
          name: this.speakerBeingConfigured.Name,
          SKU: this.$store.state.productSKU,
          price: this.$store.state.price,
          id: this.speakerBeingConfigured.Id,
        },
        {
          name: "With Power Up Charging Dock",
          SKU: this.$store.state.accessorySKU,
          price: this.$store.state.accessoryPrice,
          id: 2,
        },
      ];
    },
    customText() {
      return this.$store.state.configuration.CustomText;
    },
    socialActualURL() {
      return this.$store.state.socialImageURL;
    },
    sessionToken() {
      return this.$store.state.sessionToken;
    },
    selectedProduct() {
      return (
        this.productOptions.filter((option) => {
          return option.SKU === this.selectedSKU;
        }) || 0
      );
    },
    originalPrice() {
      const formatter = getCurrencyFormatter(
        this.$store.state.locale,
        this.$store.state.currency,
        2
      );
      console.log("formattin");
      return formatter.format(this.$store.state.speakerPrice);
    },
    accessoryPrice() {
      const formatter = getCurrencyFormatter(
        this.$store.state.locale,
        this.$store.state.currency,
        2
      );
      return formatter.format(this.$store.state.accessoryPrice);
    },
  },
  components: {
    Button,
    Share,
    ConfigurationCanvasRotator,
    Loader,
  },
};
</script>

<style lang="scss">
@import "../../scss/variables";
.mfp-wrap {
  position: fixed;
  overflow: auto;
}
.mfp-content {
  position: static;
}
.mfp-bg {
  opacity: 0.9;
  background-color: #000;
}

.mfp-content .mfp-close {
  opacity: 1;
  font-family: $font;
  top: 1.5rem;
  right: 1.5rem;
  width: 26px;
  height: 26px;
  color: black;
  &:before {
    content: "";
    background: transparent url("/images/close-black-m.png") center center
      no-repeat;
    background-size: contain;
    width: 26px;
    height: 26px;
    display: block;
  }

  @media (min-width: 768px) {
    width: 85px;
    height: 108px;
    text-align: center;
    top: 0;
    color: #fff;
    background-color: #000;
    right: 0;
    &:before {
      width: 35px;
      height: 35px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 0.5rem;
      background-image: url("/images/close-white.png");
    }
    @media (min-width: 992px) {
      transition: background-color 0.25s;
      &:hover {
        background-color: $greyDark;
      }
    }
  }
  &__text {
    display: none;
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: bold;
    line-height: 1;
    @media (min-width: 768px) {
      display: block;
    }
  }
}
.mfp-content .modal--transparent {
  padding-bottom: 4em;
  .mfp-close {
    color: #fff;
    top: 1.5rem;
    right: 1.5rem;
    width: 26px;
    height: 26px;
    background: transparent none;
    &:before {
      width: 26px;
      height: 26px;
      background-image: url("/images/close-white-m.png");
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 0.5rem;
    }

    @media (min-width: 768px) {
      width: 85px;
      height: 108px;
      text-align: center;
      top: 0;
      color: black;
      background-color: white;
      right: 0;
      &:before {
        width: 35px;
        height: 35px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 0.5rem;
        background-image: url("/images/close-black.png");
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "../../scss/variables";
.lowercase {
  text-transform: lowercase;
}

.messages {
  &__message {
    margin-top: 1em;
    font-weight: bold;
    line-height: 1.3;
    &--success {
      color: green;
    }
    &--error {
      color: red;
    }
  }
}

.btn--buy-now-mobile-wrapper {
  display: none;
  @media (max-width: 599px) {
    display: flex;
    position: sticky;
    bottom: 0;
    margin-left: -1.5em;
    margin-right: -1.5em;
    left: 0;
    right: 0;
    margin-bottom: 0;
    .btn {
      margin-bottom: 0;
    }
  }
}

.buttons-mobile {
  display: block;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  @media (min-width: 600px) {
    margin-top: 1em;
  }
  .btn {
    margin: 0;
  }

  @media (min-width: 600px) {
    margin-top: 2em;
    display: flex;
    margin-left: auto;
    margin-right: auto;
    max-width: 385px;
  }
  @media (min-width: 992px) {
    display: none;
  }
  .btn {
    display: flex;
    &--show-tablet {
      display: none;
      @media (min-width: 600px) {
        display: flex;
      }
    }
    @media (min-width: 600px) {
      margin-bottom: 1em;
    }
    &:last-child {
      margin-bottom: 0;
    }
    @media (min-width: 600px) {
      margin-right: 1em;
      margin-bottom: 0;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .btn--save-for-later-mobile {
    @media (max-width: 599px) {
      background-color: $greyDark;
      color: #fff;
      border-color: $greyDark;
    }
  }
}

.review-content {
  &__heading {
    font-size: 1.75em;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.2;
    text-transform: uppercase;
    @media (min-width: 992px) {
      max-width: none;
      margin-left: 0;
      margin-right: 0;
    }
  }
  &__body {
    line-height: 1.3;
    color: $greyDark;
    max-width: 600px;
    font-family: sans-serif;
    margin-left: auto;
    margin-right: auto;
    margin-top: 1em;
    margin-bottom: 1.5em; // this is different between top and bottom because of the line height of the heading above. 1 and 1.5 makes the margin look even
    @media (min-width: 992px) {
      max-width: none;
      margin-left: 0;
      margin-right: 0;
    }
    a {
      color: #000;
      @media (min-width: 992px) {
        transition: color 0.25s;
        &:hover {
          color: $greyDark;
        }
      }
    }
  }
}
.custom-information {
  margin-top: 1.5em;
  display: none;
  @media (min-width: 992px) {
    display: block;
  }

  &__heading {
    font-size: 3em;
    margin-bottom: 1rem;
    @media (max-width: 991px) {
      font-size: 2em;
      @media (min-height: 600px) {
        font-size: 3em;
      }
    }
  }
  &__custom-text {
    text-transform: uppercase;
    font-size: 1.1em;
    margin-bottom: 1rem;
    a {
      color: currentColor;
      font-size: 0.8em;
      font-weight: bold;
      text-decoration: none;
      border-bottom: 3px solid currentColor;
      @media (min-width: 992px) {
        transition: border-color 0.25s;
        &:hover {
          border-color: $greyMidDark;
        }
      }
    }
  }
  &__price {
    font-size: 2em;
    margin-top: 1rem;
    margin-bottom: 1rem;
    &--modal {
      @media (max-width: 991px) {
        font-size: 1.25em;
        @media (min-height: 600px) {
          font-size: 1em;
        }
      }
    }
  }
}
.select-product-wrap {
  position: relative;
  clear: both;
  max-width: 285px;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 992px) {
    margin-left: 0;
    margin-right: 0;
  }

  &:after {
    content: "\f107";
    font-family: FontAwesome;
    position: absolute;
    right: 1em;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
}
.select-product {
  text-transform: uppercase;
  font-size: 16px;
  width: 100%;
  border: 2px solid $greyMid;
  background-color: #fff;
  padding: 0.5em 2em 0.5em 0.5em;
  font-family: $font;
  -webkit-appearance: none;

  &--modal {
    background-color: transparent;
    color: #fff;
    border-color: $greyMidDark;
  }
  option {
    color: #000;
  }
  @media (min-width: 992px) {
    transition: border-color 0.25s;
    &:hover {
      border-color: $greyDark;
    }
  }
}
.btn-group {
  display: flex;
  color: #000;
  > *:first-child {
    margin-right: 1em;
  }
  > *:last-child {
    margin-right: 0;
  }
}
.btn {
  &--busy {
    color: rgba(255, 255, 255, 0.1);
    cursor: wait;
    &[disabled] {
      opacity: 1;
    }
  }
  &--agree {
    display: block;
  }
}
.speaker-images {
  padding-top: 3em;
  &__image {
    max-width: 80px;
    width: 30%;
    @media (min-height: 550px) {
      max-width: 100px;
    }
    @media (min-width: 480px) {
      max-width: 150px;
    }
  }
  .has-power-up {
    position: relative;
    padding-bottom: 2.25em;
    @media (min-width: 480px) {
      padding-bottom: 3.5em;
    }
    &:after {
      content: "";
      position: absolute;
      left: -3em;
      right: -3em;
      bottom: 0;
      background: transparent url("/images/power-up.png") center top no-repeat;
      background-size: contain;
      height: 0;
      padding-bottom: 33.75%;
      z-index: -1;
    }
  }
  img {
    margin-left: auto;
    margin-right: auto;
  }
}
.modal {
  background: #fff;
  position: relative;
  color: #000;

  max-width: 820px;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;

  &--confirm {
    padding-bottom: 4em;
  }

  &--share {
    text-align: center;
    h2 {
      margin-bottom: 1em;
    }
  }

  @media (min-width: 992px) {
    position: relative;
    color: $greyDark;
    h2 {
      color: #000;
    }
  }
  &--buy {
    text-align: center;
  }
  &--transparent {
    background: transparent;
    color: #fff;
    max-width: 100%;
    .btn-group {
      justify-content: center;
      color: #fff;
    }
  }
  &__submit-group {
    position: relative;
    margin-top: 1em;
    @media (min-width: 992px) {
      margin-top: 0;
    }
  }
  &__btn-loader {
    margin-left: 1em;
    position: absolute;
    right: calc(-20px - 1em);
    top: 50%;
    transform: translateY(-50%);
    &--overlay {
      right: auto;
      left: 50%;
      margin: 0;
      transform: translate3d(-50%, -50%, 0);
    }
    &--overlay-white {
      color: #fff;
    }
    &--overlay-black {
      color: #000;
    }
  }
  &__note {
    margin-top: 2em;
  }
  &__content-area {
    padding: 4rem 2rem 2rem;
    margin-top: 3em;

    h3 {
      text-transform: uppercase;
    }
    p {
      line-height: 1.4;
      margin-bottom: 2.35em;
      font-family: sans-serif;
      font-size: 0.8rem;
      color: $greyDark;
      &:last-child {
        margin-bottom: 0;
      }
      @media (min-width: 992px) {
        font-size: 1em;
      }
    }
    a {
      color: currentColor;
    }
    ul {
      list-style: disc outside;
      margin-left: 1.5em;
      margin-bottom: 1em;
      line-height: 1.4;
      li {
        margin-bottom: 0.5em;
        &:last-child {
          margin: 0;
        }
      }
    }

    &--legal {
      color: #000;
      p {
        color: #000;
        font-size: 1em;
        line-height: 1.4;
      }
      h3 {
        margin-bottom: 0.5em;
      }
      ul {
        font-family: sans-serif;
        color: currentColor;
      }
    }
  }
  &__disclaimer {
    margin-bottom: 3em;
    p {
      margin-bottom: 1em;
    }
  }
  &__opt-in {
    @media (min-width: 992px) {
      border-top: 1px solid $greyMidDark;
      padding-top: 2.35em;
      margin-top: 2.35em;
    }
  }
  &__label {
    display: flex;
    align-items: center;
    font-family: sans-serif;
    color: $greyDark;
    position: relative;
    font-size: 0.8rem;
    line-height: 1.38;
    @media (min-width: 992px) {
      font-size: 1rem;
    }
  }
  &__checkbox {
    opacity: 0;
    position: absolute;
    &:checked {
      + .modal__label {
        .modal__fake-checkbox {
          &:before {
            content: "";
            position: absolute;
            top: 1px;
            bottom: 1px;
            right: 1px;
            left: 1px;
            background: transparent url("/images/checkmark-black.png") center
              center no-repeat;
            background-size: contain;
            display: block;
          }
        }
      }
    }
  }
  &__fake-checkbox {
    width: 22px;
    height: 22px;
    min-width: 22px;
    min-height: 22px;
    max-width: 22px;
    max-height: 22px;
    border: 3px solid #000;
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.75rem;
    float: left;
    position: relative;
    left: 0;
    top: 0;
  }
  &__action-area {
    padding: 3em 2rem;
    background-color: $greyLight;
  }
  &__action-group {
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    @media (min-width: 992px) {
      flex-direction: row;
      align-items: stretch;
    }
  }
  &__input {
    font-size: 1em;
    padding-left: 1em;
    padding-right: 1em;
    box-sizing: border-box;
    width: 100%;
    border: none;
    font-family: $font;
    font-weight: bold;
    line-height: 50px;
    @media (min-width: 992px) {
      font-size: 18px;
    }
  }
  &__btn {
    background: #000;
    color: #fff;
    font-family: $font;
    border: none;
    // margin-top: 1em; // removed this because it messes up the sleep on it modal button
    margin-left: auto;
    margin-right: auto;
    @media (min-width: 992px) {
      height: 100%;
      transition: background-color 0.25s;
      &:hover {
        background-color: $greyDark;
      }
    }
  }
  h2 {
    font-size: 1.75em;
    margin-bottom: 0.5em;
    text-transform: uppercase;
  }
  @media (min-width: 768px) {
    &__content-area {
      padding: 75px 2rem 25px;
    }
  }
  @media (min-width: 992px) {
    h2 {
      font-size: 2.75em;
    }
    &__content-area {
      padding: 75px 100px 25px;
    }
    &__action-area {
      padding: 75px 100px 75px;
    }
  }
}
.share-image-wrap {
  position: relative;
  padding-bottom: 50%;
  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}
.share-image {
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: block;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  transition: opacity 0.3s;
  &--loading {
    opacity: 0.5;
  }
}
</style>
